import { useRef, useState, useEffect } from 'react'
import IonIcon from '@reacticons/ionicons'
import { PayPalButtons } from '@paypal/react-paypal-js'
import '../../../styles/price.css'
import { set } from 'date-fns'
import {
  getusersubscription,
  CreateSubscriptionPlan,
  GetPayPalSubscriptionDates,
  CreateUserPayPalSubscription,
  CancelPaypalSubscription,
  UpdateUserSubscription,
  CreateCustomSubscription
} from '../../../services/data'

import DateTimeFormat from '../../../util/DateTimeformat'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import LogsComponent from './viewlogs'
import { useSubscription } from '../../../context/subscriptionprovider'
import validateJSON from '../../../util/jsonvalidation'
import Cookies from 'js-cookie'
import TooltipWalkthrough from '../../../util/walkthrough'
import { useAuth } from '../../../context/logincontext'

const PriceCard = () => {
  const containerRef = useRef(null)
  const [showPopup, setShowPopup] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [planID, setPlanID] = useState([])
  const [selectedplanID, SetselectedplanID] = useState('')
  const [selectedTablePlanID, SetselectedTablePlanID] = useState('')
  const [activeplan, Setactiveplan] = useState('')
  const [activeprovider, Setactiveprovider] = useState('')
  const [currentplan, Setcurrentplan] = useState('')
  const [showPrompt, setShowPrompt] = useState(false)
  // const store_id = localStorage.getItem('store_id')
  const { userData } = useAuth()
  const user_id = validateJSON(userData)
  // const user_id = validateJSON(userdata).id
  // const user_id = validateJSON(Cookies.get('user')).id
  const navigate = useNavigate()
  const { refreshSubscription } = useSubscription()
  const [opencancelprompt, Setopencancelprompt] = useState(false)
  const [showswitchpopuppromt, Setshowswitchpromt] = useState(false)
  const [showCongratsPopup, setshowCongratsPopup] = useState(false)
  const [switchplantext, Setswitchplantext] = useState('')
  const [isFreeTrial, SetisFreeTrial] = useState('')
  const [selectedTargetPlan, setSelectedTargetPlan] = useState('')
  const [currentTrial, setCurrentTrial] = useState(null)
  const [showFreetrialPromt, SetshowFreetrialPromt] = useState(false)
  const [subscribeMessage, SetsubscribeMessage] = useState('')
  const location = useLocation()
  const params = useParams()
  
    // ✅ Extract store_id from URL (params or pathname)
    const getStoreIdFromUrl = () => {
      if (params?.store_id) return params.store_id
      const pathParts = location.pathname.split('/')
      console.log(pathParts[1])
      return pathParts[1] || null
    }
  
    const store_id = getStoreIdFromUrl()

  const checkSubscription = async () => {
    try {
      const res = await getusersubscription(
        '',
        '',
        '',
        store_id,
        'active',
        ''
      )

      if (res.success) {
        if (res.data.length === 0) {
          SetsubscribeMessage('Created')
        } else {
          SetsubscribeMessage('Updated')
        }
      }
    } catch (error) {
      console.error('Failed to fetch subscription:', error)
    }
  }

  useEffect(() => {
    checkSubscription()
  }, [subscribeMessage])

  const generalNotice =
    'Switching plan will cancel your current subscription immediately and start a new one. You will be billed for the new plan today, and no refund will be issued for the unused portion of the old plan.'

  const basicsToOtherNotice =
    'Switching your plan will cancel your current subscription and activate the new one immediately. You will be billed for the new plan today.'

  const getSwitchMessage = (trial, targetPlan) => {
    if (trial) {
      return `Are you sure you want to switch from the ${activeplan} free trial to the  ${targetPlan} plan?`
    }
    return targetPlan === 'Basics' ? basicsToOtherNotice : generalNotice
  }

  const noticeMessage = getSwitchMessage(currentTrial, selectedTargetPlan)

  const PlansName = [
    {
      planID: process.env.REACT_APP_SHOPIFY_PLAN_STANDARD_TABLE,
      plan: 'Standard'
    },
    {
      planID: process.env.REACT_APP_MAGENTO_PLAN_STANDARD_TABLE,
      plan: 'Standard'
    },
    {
      planID: process.env.REACT_APP_WEBSITE_PLAN_STANDARD_TABLE,
      plan: 'Standard'
    },
    {
      planID: process.env.REACT_APP_SHOPIFY_PLAN_ADVANCE_TABLE,
      plan: 'Advanced'
    },
    {
      planID: process.env.REACT_APP_MAGENTO_PLAN_ADVANCE_TABLE,
      plan: 'Advanced'
    },
    {
      planID: process.env.REACT_APP_WEBSITE_PLAN_ADVANCE_TABLE,
      plan: 'Advanced'
    },
    {
      planID: process.env.REACT_APP_SHOPIFY_PLAN_BASIC_TABLE,
      plan: 'Basics'
    },
    {
      planID: process.env.REACT_APP_MAGENTO_PLAN_BASIC_TABLE,
      plan: 'Basics'
    },
    {
      planID: process.env.REACT_APP_WEBSITE_PLAN_BASIC_TABLE,
      plan: 'Basics'
    },

    // Free Trials (separate for Standard & Advanced)
    {
      planID: process.env.REACT_APP_WEBSITE_PLAN_STANDARD_FREE_TABLE,
      plan: 'Free Trial'
    },
    {
      planID: process.env.REACT_APP_MAGENTO_PLAN_STANDARD_FREE_TABLE,
      plan: 'Free Trial'
    },
    {
      planID: process.env.REACT_APP_SHOPIFY_PLAN_STANDARD_FREE_TABLE,
      plan: 'Free Trial'
    },
    {
      planID: process.env.REACT_APP_WEBSITE_PLAN_ADVANCED_FREE_TABLE,
      plan: 'Free Trial'
    },
    {
      planID: process.env.REACT_APP_MAGENTO_PLAN_ADVANCED_FREE_TABLE,
      plan: 'Free Trial'
    },
    {
      planID: process.env.REACT_APP_SHOPIFY_PLAN_ADVANCED_FREE_TABLE,
      plan: 'Free Trial'
    }
  ]

  const GetUserSubscription = async () => {
    const res = await getusersubscription(
      '',
      '',
      '',
      store_id,
      'active',
      ''
    )

    if (res.success) {
      if (res.data.length === 0) return

      const activeSub = res.data[0]
      Setactiveprovider(activeSub?.subscriptionPlan?.provider)

      // Try to parse meta and get freeTrial
      try {
        const meta = JSON.parse(activeSub.meta || '{}')

        if (meta.freeTrial) {
          Setactiveplan(meta.freeTrial)
          SetisFreeTrial('FreeTrial')
        } else {
          const matchedPlan = PlansName.find(p => p.planID === activeSub.planId)
          Setactiveplan(matchedPlan?.plan || 'Unknown')
          SetisFreeTrial('')
        }
      } catch (err) {
        console.error('Meta parse error:', err)
        const matchedPlan = PlansName.find(p => p.planID === activeSub.planId)
        Setactiveplan(matchedPlan?.plan || 'Unknown')
      }
    }
  }

  useEffect(() => {
    GetUserSubscription()
  }, [activeplan])

  useEffect(() => {
    const checkstore = localStorage.getItem('chatbot')
    const plans = {
      shopify: {
        Standard: process.env.REACT_APP_SHOPIFY_PLAN_STANDARD,
        Advanced: process.env.REACT_APP_SHOPIFY_PLAN_ADVANCE,
        StandardTable: process.env.REACT_APP_SHOPIFY_PLAN_STANDARD_TABLE,
        AdvancedTable: process.env.REACT_APP_SHOPIFY_PLAN_ADVANCE_TABLE,
        BasicsTable: process.env.REACT_APP_SHOPIFY_PLAN_BASIC_TABLE,
        FreeTrialStandard:
          process.env.REACT_APP_SHOPIFY_PLAN_STANDARD_FREE_TABLE,
        FreeTrialAdvanced:
          process.env.REACT_APP_SHOPIFY_PLAN_ADVANCED_FREE_TABLE
      },
      magento: {
        Standard: process.env.REACT_APP_MAGENTO_PLAN_STANDARD,
        Advanced: process.env.REACT_APP_MAGENTO_PLAN_ADVANCE,
        StandardTable: process.env.REACT_APP_MAGENTO_PLAN_STANDARD_TABLE,
        AdvancedTable: process.env.REACT_APP_MAGENTO_PLAN_ADVANCE_TABLE,
        BasicsTable: process.env.REACT_APP_MAGENTO_PLAN_BASIC_TABLE,
        FreeTrialStandard:
          process.env.REACT_APP_MAGENTO_PLAN_STANDARD_FREE_TABLE,
        FreeTrialAdvanced:
          process.env.REACT_APP_MAGENTO_PLAN_ADVANCED_FREE_TABLE
      },
      default: {
        Standard: process.env.REACT_APP_WEBSITE_PLAN_STANDARD,
        Advanced: process.env.REACT_APP_WEBSITE_PLAN_ADVANCE,
        StandardTable: process.env.REACT_APP_WEBSITE_PLAN_STANDARD_TABLE,
        AdvancedTable: process.env.REACT_APP_WEBSITE_PLAN_ADVANCE_TABLE,
        BasicsTable: process.env.REACT_APP_WEBSITE_PLAN_BASIC_TABLE,
        FreeTrialStandard:
          process.env.REACT_APP_WEBSITE_PLAN_STANDARD_FREE_TABLE,
        FreeTrialAdvanced:
          process.env.REACT_APP_WEBSITE_PLAN_ADVANCED_FREE_TABLE
      }
    }
    setPlanID([plans[checkstore] || plans.default])
  }, [])

  const scrollLeft = () =>
    containerRef.current.scrollBy({ left: -300, behavior: 'smooth' })
  const scrollRight = () =>
    containerRef.current.scrollBy({ left: 300, behavior: 'smooth' })

  const handleswitchbasic = async selectedTableID => {
    try {
      const response = await getusersubscription(
        '',
        '',
        '',
        store_id,
        'active',
        ''
      )
      const activeSub = response.data?.[0]

      const createNewSubscription = async () => {
        const newSub = {
          user_id,
          planId: selectedTableID,
          store_id,
          startDate: new Date(),
          endDate: new Date(),
          isRecurring: true,
          notify: true,
          meta: {}
        }

        const res = await CreateCustomSubscription(newSub)
        // toast[res.success ? 'success' : 'error'](res.message, {
        //   position: 'bottom-center'
        // })
        if (res.success) {
          setshowCongratsPopup(true)
          refreshSubscription()
          GetUserSubscription()
          window.dispatchEvent(new CustomEvent('refresh-subscription-logs'))
        }
      }

      // if no plan custom subscribe
      // if (!activeSub) {
      //   await createNewSubscription()
      //   setShowPrompt(false)
      //   return
      // }

      // // custom to custom

      // if (activeSub.subscriptionPlan.provider === 'custom') {
      //   // already subscribed in custom
      //   await createNewSubscription()
      //   return
      // }

      await createNewSubscription()
      setShowPrompt(false)

      // if (activeSub.subscriptionPlan.provider === 'paypal') {
      //   // const paypalpost = {
      //   //   user_id: activeSub.user_id,
      //   //   planId: activeSub.planId,
      //   //   store_id: activeSub.store_id,
      //   //   startDate: activeSub.startDate,
      //   //   endDate: activeSub.endDate,
      //   //   isRecurring: true,
      //   //   subscriptionId: activeSub.subscription_id,
      //   //   notify: true,
      //   //   meta: {}
      //   // }
      //   // await CreateUserPayPalSubscription(paypalpost)

      //   await createNewSubscription()
      // }else{
      //   // custom to custom
      //   await createNewSubscription()
      // }
    } catch (err) {
      console.error('Error in switching plan:', err)
      toast.error('Something went wrong while switching the plan.', {
        position: 'bottom-center'
      })
    }
  }

  const handlefreetrial = async planname => {
    checkSubscription()

    let selectedTableID = null
    if (planname === 'Standard') {
      selectedTableID = planID[0]?.FreeTrialStandard
    } else if (planname === 'Advanced') {
      selectedTableID = planID[0]?.FreeTrialAdvanced
    }

    // Prepare subscription creation separately
    const createNewSubscription = async () => {
      const startDate = new Date()
      const endDate = new Date()
      endDate.setMonth(endDate.getMonth() + 1)

      const newSub = {
        user_id,
        planId: selectedTableID,
        store_id,
        startDate,
        endDate,
        isRecurring: false,
        notify: true,
        meta: {
          freeTrial: planname
        }
      }

      const createRes = await CreateCustomSubscription(newSub)

      if (createRes.success) {
        setshowCongratsPopup(true)
        refreshSubscription()
        GetUserSubscription()
        window.dispatchEvent(new CustomEvent('refresh-subscription-logs'))
      }
    }

    // Fetch current subscription
    const res = await getusersubscription(
      '',
      '',
      '',
      store_id,
      'active',
      ''
    )

    if (!res.success || res.data.length === 0) {
      console.log('No active subscription found. Ready to create trial.')
      await createNewSubscription()
      setShowPrompt(false)
      return
    }

    const activeSub = res.data[0]
    const provider = activeSub?.subscriptionPlan?.provider || ''

    try {
      const meta = JSON.parse(activeSub.meta || '{}')
      const currentTrial = meta?.freeTrial || null

      // if (provider === 'paypal') {
      //   setSelectedTargetPlan(planname)
      //   setCurrentTrial(currentTrial)
      //   setShowPrompt(true)
      //   SetshowFreetrialPromt(true)

      //   return
      // }

      if (currentTrial && currentTrial !== planname) {
        await handlecancel()
        await createNewSubscription()
        setShowPrompt(false)
        return
      }

      if (currentTrial === planname) {
        setShowPrompt(false)
        return
      }
    } catch (e) {
      console.error('Error parsing meta:', e)
    }

    await createNewSubscription()
    setShowPrompt(false)
  }

  const handleGetStarted = async plan => {
    checkSubscription()
    console.log(plan)
    // return
    const planName = plan.plan
    Setcurrentplan(planName)
    console.log(planName)
    const res = await getusersubscription(
      '',
      '',
      '',
      store_id,
      'active',
      ''
    )

    // // ✅ Free Trial Plan Logic
    // if (planName === 'Free Trial') {
    //   console.log('entered')
    //   const selectedTableID = planID[0]?.FreeTrial
    //   console.log(selectedTableID)
    //   if (res.data.length === 0) {
    //     setShowPrompt(false)
    //     await handleswitchbasic(selectedTableID) // Reuse logic
    //   } else {
    //     setShowPrompt(true)
    //   }

    //   Setactiveprovider(res?.subscriptionPlan?.provider)
    //   return
    // }

    // ✅ Basics Plan Logic
    if (planName === 'Basics') {
      const selectedTableID = planID[0]?.[`${planName}Table`]

      if (res.data.length === 0) {
        setShowPrompt(false)
        await handleswitchbasic(selectedTableID)
      } else {
        const meta = JSON.parse(res.data[0].meta || '{}')
        if (meta.freeTrial) {
          setShowPrompt(true)
          setCurrentTrial(true)
          setSelectedTargetPlan('Basics')
          // await handleswitchbasic(selectedTableID)
        } else {
          setShowPrompt(true)
        }
      }

      Setactiveprovider(res?.subscriptionPlan?.provider)
      return
    }

    // ✅ Enterprise Plan Logic
    if (planName === 'Enterprise') {
      navigate(`/store/${store_id}/feedback`)
      return
    }

    // ✅ Paid Plans
    if (res.data.length !== 0) {
      console.log(res.data)
      setShowPrompt(true)
    } else {
      setShowPopup(true)
    }

    const selectedPlanID = planID[0]?.[planName]
    const selectedTableID = planID[0]?.[`${planName}Table`]
    SetselectedplanID(selectedPlanID)
    SetselectedTablePlanID(selectedTableID)
    Setcurrentplan(planName)
    setSelectedPlan(plan)
    if (isFreeTrial === 'FreeTrial') {
      setCurrentTrial(true)
    } else {
      setCurrentTrial(false)
    }
    setSelectedTargetPlan(planName)
  }

  const handlecancel = async () => {
    try {
      const res = await getusersubscription(
        '',
        '',
        '',
        store_id,
        'active',
        ''
      )

      const activeSub = res.data[0]
      if (!activeSub) {
        console.log('No active subscription found.')
        return
      }

      if (activeSub.subscriptionPlan.provider === 'paypal') {
        console.log('Cancelling PayPal subscription...')
        const cancelRes = await CancelPaypalSubscription({
          subscriptionId: activeSub.subscription_id
        })

        if (!cancelRes.success) {
          toast.error('Failed to cancel PayPal subscription.', {
            position: 'bottom-center'
          })
          return
        }
      }

      console.log('Updating user subscription...')
      const updateRes = await UpdateUserSubscription(activeSub.id, {
        status: 'inactive'
      })

      if (updateRes.success) {
        GetUserSubscription()
        refreshSubscription()
        Setactiveplan('')
        checkSubscription()
        if (isFreeTrial === 'FreeTrial') {
          return
        }
        toast.success(` Subscription cancelled successfully.`, {
          position: 'bottom-center'
        })

        window.dispatchEvent(new CustomEvent('refresh-subscription-logs'))
      }
    } catch (error) {
      console.error('Cancellation error:', error)
      toast.error('An error occurred while cancelling the subscription.', {
        position: 'bottom-center'
      })
    }
  }

  const handleswitchplan = async selectedTableID => {
    console.log(currentplan)
    console.log(activeplan)
    console.log(selectedTableID)

    // if (currentplan === 'Free Trial') {
    //   const selectedTableID = planID[0]?.FreeTrial
    //   handleswitchbasic(selectedTableID)
    //   setShowPrompt(false)
    // }

    if (currentplan === 'Basics') {
      handleswitchbasic(selectedTableID)
      setShowPrompt(false)
    } else {
      if (currentplan === 'Standard' || currentplan === 'Advanced') {
        setShowPopup(true)
        setShowPrompt(false)
      }
    }
  }

  const closePopup = () => {
    setShowPopup(false)
    setSelectedPlan(null)
  }

  // Feature Key Map for converting readable names to actual pricing plan keys
  const featureKeyMap = {
    'AI Response': 'AIResponse',
    'Bot UI Customization': 'BotUICustomization',
    'Dataset Training': 'DatasetTraining',
    'Product Recommendation': 'ProductRecommendation',
    'Ticket Management': 'TicketManagement',
    'AI Chat Limit': 'AIChatLimit',
    'Analytics Reporting': 'AnalyticsReporting',
    'Dedicated Support': 'DedicatedSupport'
    // 'AbandonCartRecovery': 'AbandonCartRecovery', // Add more as needed
    // 'UserManagement': 'UserManagement',
  }

  const featureList = [
    'AI Response',
    'Bot UI Customization',
    'Dataset Training',
    'Product Recommendation',
    'Ticket Management',
    'AI Chat Limit',
    'Analytics Reporting',
    'Dedicated Support'
    // 'AbandonCartRecovery',
    // 'UserManagement'
  ]

  const pricingPlans = [
    {
      plan: 'Basics',
      price: 'Free',
      AIResponse: true,
      BotUICustomization: 'Limited',
      DatasetTraining: false,
      ProductRecommendation: true,
      TicketManagement: false,
      AIChatLimit: '1000',
      AnalyticsReporting: true,
      DedicatedSupport: 'Email'
    },
    {
      plan: 'Standard',
      price: '$50',
      AIResponse: true,
      BotUICustomization: true,
      DatasetTraining: true,
      ProductRecommendation: true,
      TicketManagement: true,
      AIChatLimit: '2000',
      AnalyticsReporting: true,
      DedicatedSupport: '24/7'
    },
    {
      plan: 'Advanced',
      price: '$99',
      AIResponse: true,
      BotUICustomization: true,
      DatasetTraining: true,
      ProductRecommendation: true,
      TicketManagement: true,
      AIChatLimit: '5000',
      AnalyticsReporting: true,
      DedicatedSupport: '24/7'
    },
    {
      plan: 'Enterprise',
      price: 'Contact Support',
      AIResponse: true,
      BotUICustomization: true,
      DatasetTraining: true,
      ProductRecommendation: true,
      TicketManagement: true,
      AIChatLimit: 'Unlimited',
      AnalyticsReporting: true,
      DedicatedSupport: '24/7'
    }
  ]

  const renderFeatureIcon = feature => {
    if (typeof feature === 'boolean') {
      return feature ? (
        <span className='w-5 h-5 text-[#34b233] flex items-center justify-center'>
          <IonIcon name='checkmark-outline' className='text-[22px]' />
        </span>
      ) : (
        <span className='w-5 h-5 text-[#cf142b] flex items-center justify-center'>
          <IonIcon name='close-outline' className='text-[22px]' />
        </span>
      )
    }
    return (
      <span className='w-5 h-5 text-[#34b233] flex items-center justify-center'>
        <IonIcon name='checkmark-outline' className='text-[22px]' />
      </span>
    )
  }

  const renderFeatureLabel = feature => {
    if (typeof feature === 'string') return feature
    if (typeof feature === 'object' && feature !== null) {
      return feature.details || feature.level || feature.agents || ''
    }
    return feature
  }

  return (
    <div className='relative'>
      {opencancelprompt && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] min-h-[240px] border-[1.6px] border-[#FFFFFF] shadow'>
            {/* header  */}
            <div className='flex justify-between items-center p-4 border-b'>
              <h2 className='text-lg font-semibold'>Cancel Subscription?</h2>
              <button
                onClick={() => {
                  Setopencancelprompt(false)
                }}
                className='text-gray-700 hover:text-gray-900'
              >
                <svg width='30' height='30' viewBox='0 0 24 24' fill='none'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M7.77 7.77a.925.925 0 0 1 1.3 0L12 10.7l2.93-2.93a.925.925 0 0 1 1.3 1.3L13.3 12l2.93 2.93a.925.925 0 0 1-1.3 1.3L12 13.3l-2.93 2.93a.925.925 0 1 1-1.3-1.3L10.7 12 7.77 9.07a.925.925 0 0 1 0-1.3Z'
                    fill='#373737'
                  />
                </svg>
              </button>
            </div>

            {/* body */}
            <div className='p-4 text-sm text-gray-700 h-[5rem]'>
              {activeplan === 'Basics'
                ? 'Your current subscription will be canceled immediately, and access to all features will be restricted.'
                : 'Your subscription will be canceled immediately, and you will lose access to all features. No refund will be issued for unused time.'}
              <br /> <br />
              Are you sure you want to cancel?
            </div>

            {/* footer */}
            <div className='flex justify-end gap-4 items-end h-[5rem] px-4 '>
              <button
                onClick={() => {
                  Setopencancelprompt(false)
                }}
                className='bg-[#F4F4F4] border-[1px] pt-[10px] pb-[10px] px-[20px]   bg-opacity-20  border-black  rounded-full text-[14px] text-black '
              >
                Keep Subscription
              </button>
              <button
                onClick={() => {
                  handlecancel()
                  Setopencancelprompt(false)
                }}
                className='bg-[#232328] pt-[10px] pb-[10px] px-[20px] rounded-full text-white text-[14px]'
              >
                Cancel Now
              </button>
            </div>
          </div>
        </div>
      )}
      {showCongratsPopup && (
        <div className='fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center'>
          <div className='bg-white rounded-2xl shadow-lg w-[400px]'>
            {/* Header */}
            <div className='px-6 py-4 border-b border-gray-200'>
              <h2 className='text-2xl font-bold text-green-600'>
                🎉 Congratulations!
              </h2>
            </div>

            {/* Body */}
            <div className='px-6 py-5 text-center'>
              <p className='text-gray-700'>
                {subscribeMessage === 'Created'
                  ? 'Your subscription has been successfully created.'
                  : 'Your subscription has been successfully updated.'}
              </p>
            </div>

            {/* Footer */}
            <div className='px-6 py-4 border-t border-gray-200 flex justify-end space-x-4'>
              <button
                onClick={() => setshowCongratsPopup(false)}
                className='pt-[10px] pb-[10px] px-[20px] rounded-full  border-[1px]  bg-gray-200 hover:bg-gray-300 text-gray-800'
              >
                Close
              </button>
              <button
                onClick={() => {
                  window.dispatchEvent(new Event('startTutorial'))
                  setshowCongratsPopup(false)
                }}
                className='pt-[10px] pb-[10px] px-[20px] rounded-full  bg-[#7C50DD] hover:bg-[#7C50DD] text-white'
              >
                Start Tutorial
              </button>
            </div>
          </div>
        </div>
      )}

      {showPrompt && (
        <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] min-h-[240px] border-[1.6px] border-[#FFFFFF] shadow'>
            {/* header  */}
            <div className='flex justify-between items-center p-4 border-b'>
              <h2 className='text-lg font-semibold'>
                Switch Subscription Plan?
              </h2>
              <button
                onClick={() => {
                  setShowPrompt(false)
                }}
                className='text-gray-700 hover:text-gray-900'
              >
                <svg width='30' height='30' viewBox='0 0 24 24' fill='none'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M7.77 7.77a.925.925 0 0 1 1.3 0L12 10.7l2.93-2.93a.925.925 0 0 1 1.3 1.3L13.3 12l2.93 2.93a.925.925 0 0 1-1.3 1.3L12 13.3l-2.93 2.93a.925.925 0 1 1-1.3-1.3L10.7 12 7.77 9.07a.925.925 0 0 1 0-1.3Z'
                    fill='#373737'
                  />
                </svg>
              </button>
            </div>

            {/* body */}
            <div className='p-4 text-sm text-gray-700 h-[5rem]'>
              {noticeMessage}
            </div>

            {/* footer */}
            <div className='flex justify-end gap-4 items-end h-[5rem] px-4 '>
              <button
                onClick={() => {
                  setShowPrompt(false)
                }}
                className='bg-[#F4F4F4]  bg-opacity-20 border-[1px] pt-[10px] pb-[10px] px-[20px] rounded-full border-black   text-[14px] text-black '
              >
                Stay on Current Plan
              </button>
              <button
                onClick={() => {
                  // if (activeplan === 'Standard' || activeplan ==='Advanced') {
                  //   setShowPopup(true)
                  // } else {
                  //   const selectedTableID = planID[0]?.BasicsTable
                  //   handleswitchbasic(selectedTableID)
                  // }
                  const selectedTableID = planID[0]?.BasicsTable

                  handleswitchplan(selectedTableID)
                  // console.log("hello")
                }}
                className='bg-[#232328] pt-[10px] pb-[10px] px-[20px] rounded-full text-white text-[14px]'
              >
                Switch Plan
              </button>
            </div>
          </div>
        </div>
      )}

      <div className='relative'>
        <div className='absolute left-4 top-1/2 -translate-y-1/2 z-10'>
          <button
            onClick={scrollLeft}
            className='w-12 h-12 bg-white shadow-md rounded-full flex items-center justify-center'
          >
            <IonIcon name='chevron-back-outline' size='medium' />
          </button>
        </div>

        <div
          ref={containerRef}
          className='mt-1 flex overflow-x-auto no-scrollbar scroll-smooth gap-7 px-6 py-6 md:py-6 md:px-14 lg:px-20'
        >
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`relative group bg-white pt-8 pb-8 px-7 w-full sm:w-72 md:w-[260px] lg:w-[310px] min-h-[450px] rounded-lg flex-shrink-0 flex flex-col border`}
            >
              {/* Active badge */}
              {plan.plan === activeplan && isFreeTrial === '' && (
                <span className='absolute top-[30px] right-0 bg-green-500 text-white px-5 py-2 rounded-l-[20px] text-sm font-medium'>
                  Active
                </span>
              )}

              {plan.plan === activeplan && isFreeTrial === 'FreeTrial' && (
                <span className='absolute top-[30px] right-0 bg-green-500 text-white px-5 py-2 rounded-l-[20px] text-sm font-medium'>
                  Free Trial Activated
                </span>
              )}

              <div className='flex-grow'>
                <h1 className='text-[#242536] font-bold text-[12px] uppercase'>
                  {plan.plan}
                </h1>
                <div className='mt-3 flex gap-3 items-center'>
                  <div className='flex justify-between'>
                    <h2 className='font-semibold text-[#242536] text-[31px]'>
                      {plan.price}
                    </h2>
                  </div>
                  {plan.price !== 'Contact Support' &&
                    plan.price !== 'Free' && (
                      <span className='text-[16px] font-semibold'>/month</span>
                    )}
                </div>

                <ul className='mt-6'>
                  {plan.plan === 'Enterprise' ? (
                    <>
                      <li className='flex items-center gap-3 mt-2'>
                        {renderFeatureIcon(true)}
                        <p className='text-[14px]'>
                          Custom features & integrations
                        </p>
                      </li>
                      <li className='flex items-center gap-3 mt-2'>
                        {renderFeatureIcon(true)}
                        <p className='text-[14px]'>AI Chat Limit: Flexible</p>
                      </li>
                      <li className='flex items-center gap-3 mt-2'>
                        {renderFeatureIcon(true)}
                        <p className='text-[14px]'>
                          All features from Advanced Plan
                        </p>
                      </li>
                    </>
                  ) : (
                    featureList.map((featureName, idx) => {
                      const featureKey = featureKeyMap[featureName]
                      const featureValue = plan[featureKey]

                      return (
                        <li key={idx} className='flex items-center gap-3 mt-2'>
                          {renderFeatureIcon(featureValue)}
                          <p className='text-[14px]'>
                            {featureName}
                            {typeof featureValue !== 'boolean' && (
                              <>
                                {': '}
                                <span className='font-semibold'>
                                  {renderFeatureLabel(featureValue)}
                                </span>
                              </>
                            )}
                          </p>
                        </li>
                      )
                    })
                  )}
                </ul>
              </div>

              {/* Buttons section */}
              <div className='flex flex-col items-center mt-4 gap-2'>
                {/* Primary CTA */}
                {plan.plan !== activeplan && (
                  <button
                    onClick={() => handleGetStarted(plan)}
                    className='w-full gap-2 pt-[10px] pb-[10px] px-[20px] font-semibold text-[16px] rounded-full bg-[#7C50DD] text-white hover:bg-[#693ec9]'
                  >
                    {plan.plan === 'Enterprise' ? 'Contact Us' : 'Get Started'}
                  </button>
                )}

                {plan.plan !== 'Enterprise' &&
                  plan.plan !== 'Basics' &&
                  plan.plan !== activeplan && (
                    <button
                      onClick={() => handlefreetrial(plan.plan)}
                      className='w-full relative  gap-2 pt-[10px]  pb-[10px] px-[20px] font-semibold text-[14px] rounded-full border-[2px] border-[#7C50DD] flex flex-col items-center'
                    >
                      <div className='flex items-center gap-1'>
                        <span>Or Try 1- Month Free</span>
                        <IonIcon name='arrow-forward-outline' />
                      </div>
                      <span className='text-[11px] italic absolute bg-white   bottom-[-9px] px-[3px]'>
                        {/* <span className='text-red-500'>*</span> */}
                        <span className=''> No credit card required!</span>
                      </span>
                    </button>
                  )}

                {/* Cancel button for active plan */}
                {plan.plan === activeplan && isFreeTrial === '' && (
                  <button
                    onClick={() => Setopencancelprompt(true)}
                    className='w-full pt-[10px] pb-[10px] px-[20px] font-semibold text-[16px] rounded-full bg-red-500 text-white hover:bg-red-600'
                  >
                    Cancel
                  </button>
                )}
                {plan.plan === activeplan && isFreeTrial === 'FreeTrial' && (
                  <button
                    onClick={() => Setopencancelprompt(true)}
                    className='w-full pt-[10px] pb-[10px] px-[20px] font-semibold text-[16px] rounded-full bg-red-500 text-white hover:bg-red-600'
                  >
                    Cancel Free Trial
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className='absolute right-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center'>
          <button
            onClick={scrollRight}
            className='w-12 h-12 bg-white shadow-md rounded-full flex items-center justify-center'
          >
            <IonIcon name='chevron-forward-outline' size='large' />
          </button>
        </div>
      </div>
      {/* Popup Modal */}
      {showPopup && selectedPlan && (
        <div className='fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 overflow-x-auto'>
          <div className='bg-white  rounded-xl w-[90%] max-w-md relative max-h-[470px] overflow-x-auto scrollbar-hide z-50'>
            {/* Close Button */}
            <button
              onClick={closePopup}
              className='absolute top-2 right-2 text-gray-500 hover:text-gray-800'
            >
              <IonIcon name='close-outline' size='large' />
            </button>

            {/* Header - with bottom underline */}
            <div className=' border-b border-gray-300 p-3 '>
              <h2 className='text-xl font-bold'>
                Checkout for {selectedPlan.plan} Plan
              </h2>
            </div>

            {/* PayPal Button Section */}
            <div className='paypal-container mt-3 px-4'>
              <PayPalButtons
                style={{ layout: 'vertical', shape: 'rect' }}
                createSubscription={(data, actions) => {
                  return actions.subscription.create({
                    plan_id: selectedplanID
                  })
                }}
                // createOrder={(data, actions) => {
                //   return actions.order.create({
                //     purchase_units: [
                //       {

                //         amount: {
                //           value:
                //             selectedPlan.price === 'Free' ||
                //             selectedPlan.price === 'Contact Support'
                //               ? '0.01'
                //               : selectedPlan.price.replace('$', '')
                //         }
                //       }
                //     ]
                //   })
                // }}
                onCancel={data => {
                  console.log('OnCancel', data)
                }}
                onError={err => {
                  try {
                    const match = err.message.match(
                      /"details":\s*(\[[\s\S]*?\])/
                    )
                    if (match) {
                      const detailsArray = validateJSON(match[1])
                      console.log('Extracted details array:', detailsArray)
                      toast.error(
                        `${detailsArray[0].description}. Please contact support if the issue persists.`,
                        {
                          position: 'bottom-center',
                          autoClose: 5000
                        }
                      )
                    } else {
                      console.log("No 'details' array found in error.")
                    }
                  } catch (e) {
                    console.error('Failed to extract details array:', e)
                  }
                }}
                onApprove={async (data, actions) => {
                  console.log('subscription id', data.subscriptionID)
                  localStorage.setItem('subscriptionID', data.subscriptionID)
                  const { startDate, endDate } =
                    await GetPayPalSubscriptionDates(data.subscriptionID)
                  const formatToDateOnly = date =>
                    new Date(date).toISOString().split('T')[0] // "2025-04-22"
                  // console.log(
                  //   formatToDateOnly(startDate),
                  //   formatToDateOnly(endDate)
                  // )
                  const Data = {
                    user_id: user_id,
                    planId: selectedTablePlanID,
                    store_id: store_id,
                    startDate: formatToDateOnly(startDate),
                    endDate: formatToDateOnly(endDate),
                    isRecurring: true,
                     notify: true,
                    subscriptionId: data.subscriptionID,
                    meta: {}
                  }

                  const res = await CreateUserPayPalSubscription(Data)
                  // console.log(res)
                  if (res.success) {
                    // toast.success(res.message, {
                    //   position: 'bottom-center',
                    //   autoClose: 5000
                    // })
                    refreshSubscription()
                    closePopup()
                    setshowCongratsPopup(true)
                    // Setactiveplan(currentplan);
                    GetUserSubscription()
                    setShowPrompt(false)
                    window.dispatchEvent(
                      new CustomEvent('refresh-subscription-logs')
                    )
                  } else {
                    toast.error(
                      `${res.message}. Please contact support if the issue persists.`,
                      {
                        position: 'bottom-center',
                        autoClose: 5000
                      }
                    )
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      {/* <TooltipWalkthrough pageKey={'/subscription'} /> */}
      <LogsComponent />
    </div>
  )
}

export default PriceCard
